import $ from 'jquery';

const cookies = require('js-cookie');

function getLayout() {
  return $('.layout-toggler.is-active').hasClass('layout-list') ? 'list' : 'grid';
}

if ($('#dsp_layout-toggler').length) {
  const cookiesLayout = cookies.get('srp_layout');
  const layout = cookiesLayout ? cookiesLayout : 'grid';

  $('.layout-toggler.is-active').removeClass('is-active');
  $(`.layout-toggler.layout-${layout}`).addClass('is-active');

  layout === 'list'
    ? $('.Vehicles').addClass('horizontal-view')
    : $('.Vehicles').removeClass('horizontal-view');

  $('body').on('click', function (e) {
    let $target = $(e.target);
    if ($target.hasClass('layout-toggler') || $target.parent().hasClass('layout-toggler')) {
      if (!$target.hasClass('is-active') && !$target.parent().hasClass('is-active')) {
        $('.layout-toggler').toggleClass('is-active');
        $('.Vehicles').toggleClass('horizontal-view');
        cookies.set('srp_layout', getLayout());
      }
    }
  });
}
